export enum EPaymentState {
  delivered = 'delivered',
  paid = 'paid',
  drafted = 'drafted',
}
